import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    render() {
        const { query, result, showResult, showFullForm, onSearch, onBlur, handleClick, onKeyDown, toggleShowFullForm, selectedItem, searchUrl,isAuthedicated } = this.props;
     
        return (
            <div className="quick-search-container">
                <div className="quick-search" role="search">
                    <label className="quick-search__input">
                        <svg>
                            <use href="/ui/images/sprites/be-group.svg#Search"></use>
                        </svg>
                        <input className="quick-search__input" type="search" placeholder={translate('general.searchplaceholder')}
                            autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                            onKeyDown={event => onKeyDown(event, { searchUrl })} ref={(input) => { this.searchInput = input; }}
                            onBlur={() => onBlur()} autoFocus />
                    </label>

                    <button className="quick-search__submit-button button" type="submit" onClick={event => handleClick(event, { searchUrl })}>
                        <i className="quick-search__submit-icon"></i>
                        <span className="quick-search__submit-title">{translate('general.search')}</span>
                    </button>
                </div>
                {showResult && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl} isAuthedicated={isAuthedicated}  />}
            </div>
        )
    }
}

export default QuickSearch;